import { List, Map } from 'immutable';

import { getGridLineSlotTypesConf } from 'app/configs/gridSlotTypes';
import type { RecordOfSlotEntryType } from 'app/lib/SlotEntry';

import { composeGridLineSlotId, createGridLineSlot } from '../matchGridStakes';
import type { RecordOfStakeEntity } from './betting-entities';

type GetStakeSlotsProps = {
  lineId: number;
  stakes: List<RecordOfStakeEntity>;
  sportId: number;
};

export const getStakeSlots = ({
  lineId,
  stakes,
  sportId,
}: GetStakeSlotsProps): List<RecordOfSlotEntryType> => {
  return stakes?.reduce((map, stake) => {
    return getGridLineSlotTypesConf(sportId, lineId, stake.type).reduce(
      (map, { slotType, filter }) => {
        if (
          filter && !Object.keys(filter).every((key) => {
            return stake?.params.has(key) && stake?.params.get(key) === filter[key];
          })
        ) {
          // skip adding stake to a slot
          return map;
        }

        const slotId = composeGridLineSlotId(slotType, stake.id);
        if (map.has(slotId)) {
          const stakes = map.get(slotId)?.get('stakes');
          if (!stakes) {
            return map;
          }
          return map.setIn([slotId, 'stakes'], stakes.push(stake));
        }

        return map.set(slotId, createGridLineSlot(slotId, slotType, stake));
      },
      map,
    );
  }, Map<string | number, RecordOfSlotEntryType>())
    .toList()
    .sort((a, b) => (a.index && b.index) && a.index - b.index || a.sequencer && a.sequencer(a, b))
    .map((slot) => {
      return slot.set('stakes', slot.stakes.sort((a, b) => slot.sequencer && slot.sequencer(a, b)));
    });
};
